import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

/**
 * @deprecated Use SubscriptionManager from @app/shared-components instead.
 * This class will be removed in a future version.
 * 
 * Migration:
 * ```typescript
 * // OLD
 * import { Unsubscriber } from "@app/shared/components";
 * export class MyComponent extends Unsubscriber { }
 * 
 * // NEW
 * import { SubscriptionManager } from "@app/shared-components";
 * export class MyComponent extends SubscriptionManager { }
 * ```
 */
@Component({ template: "" })
export class Unsubscriber implements OnDestroy {
  set sub(subscription: Subscription) {
    this.subscriptions.push(subscription);
  }

  private subscriptions: Subscription[] = [];

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
    this.subscriptions = [];
  }
}
